import { ref } from "vue"

export const useState = (defaultValue, deep = true) => {
  const val = ref(defaultValue);
  function setValue(_value) {
    if (deep) {
      if (typeof _value === "object") {
        if (Array.isArray(_value)) {
          return val.value = [..._value];
        }
        return val.value = { ..._value };
      }
    }
    val.value = _value;
  }
  return [val, setValue]
}